import { Check, X } from 'lucide-react';

interface BookingStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  status: 'success' | 'failed';
  message?: string;
}

export default function BookingStatusModal({
  isOpen,
  onClose,
  status,
  message,
}: BookingStatusModalProps) {
  if (!isOpen) return null;

  const isSuccess = status === 'success';

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-[380px] rounded-3xl bg-white shadow-2xl sm:max-w-[420px]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Content */}
        <div className="flex flex-col items-center px-8 py-10 sm:px-10 sm:py-12">
          {/* Icon */}
          <div
            className={`mb-6 flex h-24 w-24 items-center justify-center rounded-full sm:h-28 sm:w-28 ${
              isSuccess ? 'bg-[#5CB85C]' : 'bg-red-500'
            }`}
          >
            {isSuccess ? (
              <Check className="h-14 w-14 stroke-[4] text-white sm:h-16 sm:w-16" />
            ) : (
              <X className="h-14 w-14 stroke-[4] text-white sm:h-16 sm:w-16" />
            )}
          </div>

          {/* Title */}
          <h2 className="mb-3 text-2xl font-bold text-gray-900 sm:text-3xl">
            {isSuccess ? 'Success!' : 'Failed!'}
          </h2>

          {/* Message */}
          <p className="mb-8 text-center text-sm leading-relaxed text-gray-700 sm:text-base">
            {message ||
              (isSuccess
                ? 'Please check your email for the meeting details.'
                : 'Something went wrong. Please try again.')}
          </p>

          {/* Button */}
          <button
            onClick={onClose}
            className="w-full rounded-lg bg-[#F0AD4E] py-3 text-sm font-semibold text-gray-900 transition-all hover:bg-[#EC971F] sm:text-base"
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}
